import { useRef, useState } from 'react';
import '../App.css';
import Table from './Table';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import { aplicarMascaraCpfCnpj } from '../utils/MaskUtils';
import { handleErrors, request } from '../utils/ApiUtils';

import Button from '@mui/material/Button';
import Input from './Input';
import { showNotification } from '../utils/NotificationUtils';
import CheckboxComConfirmacao from './ModalConfirmacao';
import { FaUserFriends } from 'react-icons/fa';

function Colaboradores() {
    const navigate = useNavigate();

    const [filter, setFilter] = useState('');

    const [pageData, setPageData] = useState({});
    const [dataArray, setDataArray] = useState([]);
    const [loading, setLoading] = useState({loading: false});
    const firstRender = useRef(0);
    const [fetchListError, setFetchListError] = useState();
    const [refreshKey, setRefreshKey] = useState(0);
    const [itemEditModal, setItemEditModal] = useState(null)

    const triggerRefresh = () => setRefreshKey((prev) => prev + 1);

    const carregarDados = async (page = 0) => {
        setLoading({loading: true});

        request(`colaboradores/paginated?page=${page}&query=${filter || ''}`, {
            type: 'POST',
            body: JSON.stringify({}),
            callback: (data) => {
                setPageData(data);
                setDataArray(data.content);
            },
            callbackError: (responseData, message) => { handleErrors(responseData, 'Falha ao buscar colaboradores: '+message, {setFetchListError}) },
            finally: () => setLoading({loading: false})
        })
    };


    useEffect(() => { carregarDados(); }, []);

    useEffect(() => {
        if (firstRender.current < 1) {
            firstRender.current = firstRender.current+1;
            return;
        }
        carregarDados(0); 
    }, [filter]);

    const salvarColaborador = async (colaborador) => {
        const method = colaborador.id ? "PUT" : "POST";
        const url = colaborador.id ? `colaboradores/${colaborador.id}` : "POST";

        request(url, {
            type: method,
            body: JSON.stringify(colaborador),
            callback: (data) => {
                showNotification('Colaborador alterado', 'success');
            },
            callbackError: (responseData, message) => {
                responseData?.error ?
                    showNotification(responseData.error, 'error') :
                    showNotification('Não foi possível alterar o colaborador, revise o cadastro.', 'error');

            },
            finally: () => {
                triggerRefresh()
            }
        })
    };


    const tableParams = {
        query: (page) => carregarDados(page),
        triggerRefresh: triggerRefresh,
        columns: [
            {
                label: "Documento",
                width: "15%",
                type: "input",
                key: "documento",
                disable: true,
                getValue: (item) => aplicarMascaraCpfCnpj(item.documento)
            },
            {
                label: "Nome",
                width: "30%",
                type: "input",
                key: "nome",
                disable: true,
                getValue: (item) => item.nome
            },
            {
                label: "Setor",
                width: "20%",
                type: "input",
                key: "setor",
                disable: true,
                getValue: (item) => item.setor
            },
            {
                label: "Captador",
                width: "10%",
                type: "checkbox",
                disabled: true,
                key: "captador",
                getValue: (item) => item.captador,
                onClick: (item) => {
                    item.captador = !item.captador
                    salvarColaborador(item);
                }
            },
            {
                label: "Fechador",
                width: "10%",
                type: "checkbox",
                disabled: true,
                key: "ativo",
                getValue: (item) => item.fechador,
                onClick: (item) => {
                    item.fechador = !item.fechador
                    salvarColaborador(item);
                }
            },
            {
                label: "Recebe Comissão",
                width: "10%",
                type: "checkbox",
                disabled: true,
                key: "recebeComissao",
                getValue: (item) => item.recebeComissao,
                onClick: (item) => {
                    item.recebeComissao = !item.recebeComissao
                    salvarColaborador(item);
                }
            },
            {
                label: "Ativo",
                width: "5%",
                type: "checkbox",
                disabled: true,
                key: "ativo",
                getValue: (item) => item.ativo,
                onClick: (item) => {
                    if (!item.ativo) {
                        item.ativo = !item.ativo;
                        salvarColaborador(item);
                    } else {
                        setItemEditModal(item);
                    }
                }
            },
            {
                label: "Editar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<VisibilityIcon />),
                onClick: (colaborador) => navigate(`/colaboradores/cadastro/${colaborador.id}`)
            }
        ]
    };

    return (
        <div className="form-container list-page">


            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                top: "0", // Aqui muda pra aparecer no topo
                right: "30px",
                maxHeight: "100vh",
                zIndex: 9999
            }}></div>

            <div className="header-container">
                <div className="page-title-content">
                    <FaUserFriends aria-hidden="true" />
                    <h1 style={{ color: 'black' }}>Equipe</h1>
                </div>
                <Button className="new-contract-button" variant="contained" onClick={() => navigate(`/colaboradores/cadastro`)}>
                    Novo colaborador
                </Button>
            </div>

            <div className='row'>

                <Input id="filtro"
                    parameters={{
                        width: '30%', label: "Filtre por nome ou documento ", onChange: (value) => {
                            setFilter(value);
                        }
                    }} />
            </div>

            {itemEditModal && <CheckboxComConfirmacao parameters={{
                message: "Atenção: Ao inativar o colaborador, ele não poderá mais ser selecionado na aba de Contratos. Tem certeza de que deseja continuar?",
                confirm: () => {
                    itemEditModal.ativo = false;
                    salvarColaborador(itemEditModal);
                    setItemEditModal(null);
                },
                cancel: () => {
                    setItemEditModal(null);
                }
            }}>
            </CheckboxComConfirmacao>}

            <Table params={tableParams} dataArray={dataArray} pageData={pageData} filter={filter} refreshKey={refreshKey} loading={loading} errorOccurred={fetchListError} />
        </div>
    );
}

export default Colaboradores;
